// Authentication service for handling login state and remember me functionality
export const authService = {
  // Check if user is authenticated
  isAuthenticated: () => {
    const token = localStorage.getItem('token');
    if (!token) return false;
    
    try {
      // Basic JWT token validation (check if not expired)
      const payload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Date.now() / 1000;
      return payload.exp > currentTime;
    } catch (error) {
      // If token is malformed, remove it
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      return false;
    }
  },

  // Get current user from localStorage
  getCurrentUser: () => {
    try {
      const user = localStorage.getItem('user');
      return user ? JSON.parse(user) : null;
    } catch (error) {
      return null;
    }
  },

  // Persist user profile to localStorage
  setCurrentUser: (user) => {
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
    }
  },

  // Get saved username for remember me
  getSavedUsername: () => {
    return localStorage.getItem('savedUsername') || '';
  },

  // Check if remember me is enabled
  isRememberMeEnabled: () => {
    return localStorage.getItem('rememberMe') === 'true';
  },

  // Clear all auth data
  clearAuth: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('rememberMe');
    localStorage.removeItem('savedUsername');
  },

  // Set remember me
  setRememberMe: (username) => {
    localStorage.setItem('rememberMe', 'true');
    localStorage.setItem('savedUsername', username);
  },

  // Clear remember me
  clearRememberMe: () => {
    localStorage.removeItem('rememberMe');
    localStorage.removeItem('savedUsername');
  }
};
